'use strict';

const _ = require('lodash');
const moment = require('moment');
// Vue is a frontend package so must be included like this for compatibility with the frontend webpack in elsa
// otherwise simply doing `require('vue');` won't work in elsa
const Vue = require('vue/dist/vue');

const consts = require('../consts');

function _getDetailsIfMissing(envelopeType) {
  return consts.ENVELOPES_DEFAULT_DETAILS[envelopeType];
}

function create({ actuals, originalAmount: predictedAmount, type, details, balanceDate, id }, updatedAt) {
  return new Vue({
    data: {
      actuals,
      predictedAmount,
      type,
      details: details || _getDetailsIfMissing(type),
      balanceDate,
      updatedAt,
      id,
    },
    computed: {
      actualsAmount() {
        const outSum = _.sum(_.map(this.actuals, a => a.billingAmount || 0));
        const inSum = _.sum(_.map(this.actuals, a => a.incomeAmount || 0));
        return outSum - inSum;
      },
      hasActuals() {
        return this.actuals.length > 0;
      },
      actualsExceedPrediction() {
        return Math.abs(this.actualsAmount) > Math.abs(this.predictedAmount);
      },
      balanceDatePassed() {
        return moment(this.updatedAt) > moment(this.balanceDate);
      },
      shouldBalance() {
        const balanceDatePassed = this.balanceDate && this.balanceDatePassed;
        const fixedAndFilled = (this.type === consts.FIXED_ENVELOPE_TYPE || this.type === consts.ROLLING_CREDIT_ENVELOPE_TYPE) && this.hasActuals;
        const exceededPrediction = this.actualsExceedPrediction;
        return balanceDatePassed || fixedAndFilled || exceededPrediction;
      },
      balancedAmount() {
        const { actualsAmount } = this;
        return this.shouldBalance ? actualsAmount : this.predictedAmount;
      },
      isExpense() {
        return this.predictedAmount >= 0 && (this.details && !this.details.isIncome);
      },
      cashculation() {
        return {
          type: this.type,
          originalAmount: this.predictedAmount,
          balancedAmount: this.balancedAmount,
          actualsAmount: this.actualsAmount,
          balanceDate: this.balanceDate,
          id: this.id,
          balanceDatePassed: this.balanceDatePassed,
          details: _.cloneDeep(this.details),
        };
      },
    },
    methods: {
      toJson() {
        return {
          type: this.type,
          details: _.cloneDeep(this.details),
          actuals: _.cloneDeep(this.actuals),
          originalAmount: this.predictedAmount,
          balancedAmount: this.balancedAmount,
          balanceDate: this.balanceDate,
          id: this.id,
          balanceDatePassed: this.balanceDatePassed,
        };
      },
    },
  });
}

module.exports = {
  create,
};
